import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getWithdrawalSettings,
  setWithdrawalSettings
} from '@/api/settings-api'

// Whether a portal shows the EU withdrawal form; only REVER can change it.
export function useWithdrawalSettings(ecommerceId: string | undefined) {
  const queryClient = useQueryClient()
  const queryKey = ['withdrawal-settings', ecommerceId]

  const query = useQuery({
    queryKey,
    queryFn: () => getWithdrawalSettings(ecommerceId ?? ''),
    enabled: !!ecommerceId,
    // The navbar asks on every page; it changes only when REVER switches it.
    staleTime: 5 * 60_000
  })

  const mutation = useMutation({
    mutationFn: (enabled: boolean) =>
      setWithdrawalSettings(ecommerceId ?? '', enabled),
    // Keyed by the store the save changed: the selection may have moved on before it answers.
    onSuccess: (data) =>
      queryClient.setQueryData(['withdrawal-settings', data.ecommerce_id], data)
  })

  return {
    enabled: !!query.data?.enabled,
    // Without an ecommerce the query never runs, and a pending query would spin forever.
    loading: query.isPending && !!ecommerceId,
    failed: query.isError,
    reload: () => query.refetch(),
    saving: mutation.isPending,
    setEnabled: mutation.mutateAsync
  }
}
